(() => {
  const swiffyslider = {
    version: '1.4.1',
    init(e = document.body) {
      for (let t of e.querySelectorAll('.swiffy-slider')) this.initSlider(t);
    },
    initSlider(e) {
      for (let t of e.querySelectorAll('.slider-nav')) {
        let i = t.classList.contains('slider-nav-next');
        t.addEventListener('click', () => this.slide(e, i), { passive: !0 });
      }
      for (let t of e.querySelectorAll('.slider-indicators'))
        t.addEventListener('click', () => this.slideToByIndicator()),
          this.onSlideEnd(e, () => this.handleIndicators(e), 60);
      if (e.classList.contains('slider-nav-autoplay')) {
        const time = e.getAttribute('data-slider-nav-autoplay-interval') || e.parentElement.getAttribute('data-slider-nav-autoplay-interval');
        const t = time
          ? time
          : 2500;
        this.autoPlay(e, t, e.classList.contains('slider-nav-autopause'));
      }
      if (['slider-nav-autohide', 'slider-nav-animation'].some((t) => e.classList.contains(t))) {
        const t = e.getAttribute('data-slider-nav-animation-threshold')
          ? e.getAttribute('data-slider-nav-animation-threshold')
          : 0.3;
        this.setVisibleSlides(e, t);
      }
    },
    setVisibleSlides(e, t = 0.3) {
      let i = new IntersectionObserver(
        (t) => {
          t.forEach((e) => {
            e.isIntersecting ? e.target.classList.add('slide-visible') : e.target.classList.remove('slide-visible');
          }),
            e.querySelector('.slider-container>*:first-child').classList.contains('slide-visible')
              ? e.classList.add('slider-item-first-visible')
              : e.classList.remove('slider-item-first-visible'),
            e.querySelector('.slider-container>*:last-child').classList.contains('slide-visible')
              ? e.classList.add('slider-item-last-visible')
              : e.classList.remove('slider-item-last-visible');
        },
        { root: e.querySelector('.slider-container'), threshold: t }
      );
      for (let t of e.querySelectorAll('.slider-container>*')) i.observe(t);
    },
    slide(e, t = !0) {
      const i = e.querySelector('.slider-container'),
        s = e.classList.contains('slider-nav-page'),
        l = e.classList.contains('slider-nav-noloop'),
        r = e.classList.contains('slider-nav-nodelay'),
        o = i.children,
        n = parseInt(window.getComputedStyle(i).columnGap),
        a = o[0].offsetWidth + n;
      let d = t ? i.scrollLeft + a : i.scrollLeft - a;
      s && (d = t ? i.scrollLeft + i.offsetWidth : i.scrollLeft - i.offsetWidth),
        i.scrollLeft < 1 && !t && !l && (d = i.scrollWidth - i.offsetWidth),
        i.scrollLeft >= i.scrollWidth - i.offsetWidth && t && !l && (d = 0),
        i.scroll({ left: d, behavior: r ? 'auto' : 'smooth' });
    },
    slideToByIndicator() {
      const e = window.event.target,
        t = Array.from(e.parentElement.children).indexOf(e),
        i = e.parentElement.children.length,
        s = e.closest('.swiffy-slider'),
        l = (s.querySelector('.slider-container').children.length / i) * t;
      this.slideTo(s, l);
    },
    slideTo(e, t) {
      const i = e.querySelector('.slider-container'),
        s = parseInt(window.getComputedStyle(i).columnGap),
        l = i.children[0].offsetWidth + s,
        r = e.classList.contains('slider-nav-nodelay');
      i.scroll({ left: l * t, behavior: r ? 'auto' : 'smooth' });
    },
    onSlideEnd(e, t, i = 125) {
      let s;
      e.querySelector('.slider-container').addEventListener(
        'scroll',
        function () {
          window.clearTimeout(s), (s = setTimeout(t, i));
        },
        { capture: !1, passive: !0 }
      );
    },
    autoPlay(e, t, i) {
      t = t < 750 ? 750 : t;
      let s = setInterval(() => this.slide(e), t);
      const l = () => this.autoPlay(e, t, i);
      return (
        i &&
          (['mouseover', 'touchstart'].forEach(function (t) {
            e.addEventListener(
              t,
              function () {
                window.clearTimeout(s);
              },
              { once: !0, passive: !0 }
            );
          }),
          e.addEventListener(
            'mouseout',
            function () {
              l();
            },
            { once: !0, passive: !0 }
          )),
        s
      );
    },
    handleIndicators(e) {
      const t = e.querySelector('.slider-container'),
        i = t.scrollWidth - t.offsetWidth,
        s = t.scrollLeft / i;
      for (let t of e.querySelectorAll('.slider-indicators')) {
        let e = t.children,
          i = Math.abs(Math.round((e.length - 1) * s));
        for (let t of e) t.classList.remove('active');
        e[i].classList.add('active');
      }
    },
  };
  (window.swiffyslider = swiffyslider),
    document.currentScript.hasAttribute('data-noinit') ||
      window.addEventListener('load', () => {
        swiffyslider.init();
      });

  class Slider extends HTMLElement {
    constructor() {
      super();
      this.desktopSettings = this.getAttribute('data-desktop-settings');
      this.tabletSettings = this.getAttribute('data-tablet-settings');
      this.mobileSettings = this.getAttribute('data-mobile-settings');
      this.desktopNav = this.querySelector('[data-desktop-nav]');
      this.tabletNav = this.querySelector('[data-tablet-nav]');
      this.mobileNav = this.querySelector('[data-mobile-nav]');
      this.slider = this.querySelector('[data-start]');
      this.sliderClasses = this.slider.getAttribute('class');
      this.sliderContainer = this.querySelector('[data-container]');
      this.sliderContainerClasses = this.sliderContainer.getAttribute('class');
      this.activeDevice = '';
      if (window.matchMedia('(max-width: 576px)').matches && this.mobileSettings != null) {
        this.enableSlider(this.mobileSettings, 'mobile');
      } else if (window.matchMedia('(max-width: 992px)').matches && this.tabletSettings != null) {
        this.enableSlider(this.tabletSettings, 'tablet');
      } else if (this.desktopSettings != null) {
        this.enableSlider(this.desktopSettings, 'desktop');
      }
      this.watchResize();
    }
    watchResize() {
      window.addEventListener('resize', () => {
        if (window.matchMedia('(max-width: 576px)').matches) {
          if (this.activeDevice !== 'mobile' && this.mobileSettings != null) {
            this.removeSlider();
            this.enableSlider(this.mobileSettings, 'mobile');
          } else if (this.mobileSettings == null) {
            this.removeSlider();
            this.activeDevice = 'mobile';
          }
        } else if (window.matchMedia('(max-width: 992px)').matches) {
          if (this.activeDevice !== 'tablet' && this.tabletSettings != null) {
            this.removeSlider();
            this.enableSlider(this.tabletSettings, 'tablet');
          } else if (this.tabletSettings == null) {
            this.removeSlider();
            this.activeDevice = 'tablet';
          }
        } else {
          if (this.activeDevice !== 'desktop' && this.desktopSettings != null) {
            this.removeSlider();
            this.enableSlider(this.desktopSettings, 'desktop');
          } else if (this.desktopSettings == null) {
            this.removeSlider();
            this.activeDevice = 'desktop';
          }
        }
      });
    }
    removeSlider() {
      this.slider.className = this.sliderClasses;
      this.sliderContainer.className = this.sliderContainerClasses;
      if (this.mobileNav) this.mobileNav.style.display = 'none';
      if (this.tabletNav) this.tabletNav.style.display = 'none';
      if (this.desktopNav) this.desktopNav.style.display = 'none';
    }
    enableSlider(settings, device) {
      this.slider.className += ' swiffy-slider ' + settings;
      this.sliderContainer.className += ' slider-container';
      this.activeDevice = device;
      swiffyslider.initSlider(this.slider);
      if (device === 'mobile') {
        if (this.mobileNav) this.mobileNav.style.display = 'block';
        if (this.tabletNav) this.tabletNav.style.display = 'none';
        if (this.desktopNav) this.desktopNav.style.display = 'none';
      } else if (device === 'tablet') {
        if (this.mobileNav) this.mobileNav.style.display = 'none';
        if (this.tabletNav) this.tabletNav.style.display = 'block';
        if (this.desktopNav) this.desktopNav.style.display = 'none';
      } else if (device === 'desktop') {
        if (this.mobileNav) this.mobileNav.style.display = 'none';
        if (this.tabletNav) this.tabletNav.style.display = 'none';
        if (this.desktopNav) this.desktopNav.style.display = 'block';
      }
    }
  }
  customElements.define('main-slider', Slider);

  // Global review stars component
  if (!customElements.get('component-review-stars')) {
    customElements.define('component-review-stars', class ReviewStars extends HTMLElement {
      constructor() {
        super();
        this.props = {
          reviews: this.dataset.reviews,
          total: this.dataset.total,
          type: this.dataset.type
        }
      }
      connectedCallback() {
        this.render();
      }
      render() {
        let count = 0;
        const reviews = document.createElement("div");
        reviews.classList.add('review-stars');
        const roundedRating = Math.round(this.props.reviews*2)/2;
        const fullStars = Math.floor(roundedRating);
        const halfStars = Math.ceil(roundedRating % 1);
        for (let i = 0; i < fullStars; i++) {
          const fullStar = document.createElement("span");
          fullStar.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z"></path></svg>';
          reviews.appendChild(fullStar);
          count++;
        }
        for (let i = 0; i < halfStars; i++) {
          const halfStar = document.createElement("span");
          halfStar.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="css-185y4rx-StyledStar e1xuoq912"><path d="M12 5.173l2.335 4.817 5.305.732-3.861 3.71.942 5.27-4.721-2.524v-12.005zm0-4.586l-3.668 7.568-8.332 1.151 6.064 5.828-1.48 8.279 7.416-3.967 7.416 3.966-1.48-8.279 6.064-5.827-8.332-1.15-3.668-7.569z"></path></svg>';
          reviews.appendChild(halfStar);
          count++;
        }
        while (count < 5) {
          const emptyStar = document.createElement("span");
          emptyStar.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="css-185y4rx-StyledStar e1xuoq912"><path d="M12 5.173l2.335 4.817 5.305.732-3.861 3.71.942 5.27-4.721-2.524-4.721 2.525.942-5.27-3.861-3.71 5.305-.733 2.335-4.817zm0-4.586l-3.668 7.568-8.332 1.151 6.064 5.828-1.48 8.279 7.416-3.967 7.416 3.966-1.48-8.279 6.064-5.827-8.332-1.15-3.668-7.569z"></path></svg>';
          reviews.appendChild(emptyStar);
          count++;
        }
        this.appendChild(reviews);
        if (this.props.total) {
          const total = document.createElement('span');
          if (this.props.type === 'product') {
            total.classList.add('reviews-count--product');
            total.innerHTML = `${Number(this.props.total).toLocaleString()} Reviews`;
          } else if (this.props.type === 'featured-product') {
            total.classList.add('reviews-count');
            total.innerHTML = `${this.props.total}`;
          } else {
            total.classList.add('reviews-count');
            let formattedTotal = Math.floor(Number(this.props.total) / 1000);
            if (formattedTotal != 0) {
              total.innerHTML = `(${Math.floor(Number(this.props.total) / 1000)}K)`;
            } else {
              total.innerHTML = `(${this.props.total})`;
            }
          }
          this.appendChild(total);
        }
      }
    });
  }
})();

// Set user locale in the window object
(() => {
  const isCA = window.Shopify.country === 'CA';
  window.userLocale = isCA ? 'en-ca' : 'en-us';
})();

// Attach scroll-to behavior to any anchor link in the current page
(() => setTimeout(() => {
  const anchorLinks = document.querySelectorAll('[data-anchor]');

  if (!anchorLinks.length) return;

  anchorLinks.forEach(anchorLink => {
    const anchor = anchorLink.dataset.anchor;
    if (!anchor?.startsWith('#')) {
      console.error(`Error: no anchor link specified`);
      return;
    }

    anchorLink.onclick = function goToAnchor(event) {
      event.stopPropagation();
      event.preventDefault();
      const target = document.querySelector(anchor);

      if (!target) {
        console.error("Error: target destination to scroll doesn't exist");
      } else {
        scrollTo(target);
      }
    }
  });

  function scrollTo(target) {
    const header = document.getElementById("simple-header") || document.getElementById("shopify-section-header-widget");
    const headerHeight = header?.offsetHeight;

    if (!headerHeight) return;

    const scrollDestination = Math.floor(target.getBoundingClientRect().top)
      - headerHeight
      + window.pageYOffset;

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion)',
    ).matches;

    const behavior = prefersReducedMotion ? 'auto': 'smooth';

    window.scrollTo({ top: scrollDestination, left: 0, behavior });
  }
}))()

window.klaviyoIdentify = (email) => {
  try {
    window.klaviyo && window.klaviyo.push(['identify', { 'email': email }]);
  } catch (e) {
    // do nothing...
  }
}
